const itemsModel = vm => ({
  title: vm.$gettext('Shipping Items'),
  endpoint: 'shipping-items',
  editInPlace: true,
  noIdLink: true,
  allowNew: false,
  showIncludes: false,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'shipping_id',
      label: vm.$gettext('Shipping ID'),
      filter: 'uuid',
      sortable: true
    },
    {
      key: 'item_pack_id',
      label: vm.$gettext('Item Pack ID'),
      filter: 'uuid',
      sortable: true
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      editable: true
    },
    {
      key: 'reference_code',
      label: vm.$gettext('Ref. Code')
    },
    {
      key: 'width',
      label: vm.$gettext('Width'),
      editable: true
    },
    {
      key: 'height',
      label: vm.$gettext('Height'),
      editable: true
    },
    {
      key: 'length',
      label: vm.$gettext('Length'),
      editable: true
    },
    {
      key: 'weight',
      label: vm.$gettext('Weight'),
      editable: true
    },
    {
      key: 'size',
      label: vm.$gettext('Item Size'),
      formatter: (value, key, item) => {
        return (
          (item.width || 0) +
          '×' +
          (item.height || 0) +
          '×' +
          (item.length || 0) +
          'cm - ' +
          (item.weight || 0) +
          'g'
        )
      }
    },
    {
      key: 'quantity',
      label: vm.$gettext('Quantity')
    },
    {
      key: 'serial_number',
      label: vm.$gettext('Serial Number'),
      type: Array,
      filter: 'arrayToList',
      editable: true
    }
  ],
  filters: [],
  includes: [],
  exclude: ['width', 'height', 'length', 'weight']
})

export default itemsModel
